import styled from 'styled-components';

export const TabContainer = styled.div`
  padding: 2rem;
`;
